import React, { useState } from "react";

// Chip-style tag editor: Enter or comma adds, × removes. Max 10 tags.
export const TagInput = ({ value = [], onChange, max = 10 }) => {
  const [draft, setDraft] = useState("");
  const add = (raw) => {
    const t = raw.trim().replace(/^#/, "").slice(0, 24);
    if (!t || value.length >= max || value.some((v) => v.toLowerCase() === t.toLowerCase())) return;
    onChange([...value, t]);
  };
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(draft); setDraft(""); }
    else if (e.key === "Backspace" && !draft && value.length) onChange(value.slice(0, -1));
  };
  return (
    <div className="flex flex-wrap gap-1.5 p-2 rounded-xl bg-black/40 border border-white/10" data-testid="project-tags">
      {value.map((t) => (
        <span key={t} className="inline-flex items-center gap-1 h-7 pl-2.5 pr-1 rounded-full bg-fuchsia-500/15 text-fuchsia-100 text-xs font-bold">
          #{t}
          <button type="button" onClick={() => onChange(value.filter((v) => v !== t))} aria-label={`Remove ${t}`}
            className="w-5 h-5 rounded-full hover:bg-white/10" data-testid={`project-tag-remove-${t}`}>×</button>
        </span>
      ))}
      {value.length < max && (
        <input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={onKey}
          onBlur={() => { if (draft) { add(draft); setDraft(""); } }}
          placeholder={value.length ? "Add tag" : "Add tags (press Enter)"}
          className="flex-1 min-w-[110px] h-7 bg-transparent text-sm text-white placeholder:text-gray-500 focus:outline-none"
          data-testid="project-tag-input" />
      )}
    </div>
  );
};

export default TagInput;
